<template>
  <div>
    <v-container>
      <v-textarea
        class="mt-2 mb-n7"
        filled
        v-model="powerFewShotRes"
        no-resize
        height="260"
        counter
        hide-details="auto"
        color="indigo"
      ></v-textarea>
    </v-container>
    <v-container class="d-flex mt-6 justify-end">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="indigo darken-1" v-bind="attrs" v-on="on" class="mx-1 mt-n2" icon @click="handleCopy">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>
        <span>Copy</span>
      </v-tooltip>
    </v-container>
  </div>
</template>

<script>
import {marked} from 'marked';
import DOMPurify from 'dompurify';
export default {
  name: 'PowerFewShotRight',
  data() {
    return {
      powerFewShotRes: '',
    }
  },
  computed: {
  },
  created() {
    this.$store.watch(
      (state) => state.powerFewShotMsg.powerFewShotRes, () => {
        this.powerFewShotRes = this.$store.getters.getpowerFewShotRes;
      }, {
        deep: true
      }
    );
    this.powerFewShotRes = this.$store.getters.getpowerFewShotRes;
  },
  mounted() {

  },

  methods: {
    htmlfy(answer) {
      // console.log(DOMPurify.sanitize(marked.parse(answer)))
      return DOMPurify.sanitize(marked.parse(answer));      
    },
    handleCopy() {
      const anwser=this.htmlfy(this.powerFewShotRes)
      const temp = document.createElement('div');
      temp.innerHTML = anwser;
      document.body.appendChild(temp);
      const range = document.createRange();
      range.selectNode(temp);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();
      document.body.removeChild(temp);
      this.$store.commit('HandlePromptBoomSnackBar', 'Copied')
    }
  }

};
</script>

<style scoped>
</style>